import { TeamIntegrationSchema } from '@rhythmic/types'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'

export const TEAM_INTEGRATION_TABLE = '"public"."teamIntegrations"'

export const TeamIntegrationConfig: CollectionBuildRequestConfig = {
  collectionType: 'query',
  table: TEAM_INTEGRATION_TABLE,
  partitionKey: 'team_id',
  key: 'id',
  apiEndpoint: '/api/team/[team_id]/integrations',
  where: {},
  schema: TeamIntegrationSchema,
}
